import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { TitleLarge500, TitleXLarge500 } from '@nebula/global-styles';
import { useMediaQuery } from '@nebula/hooks';

import { products } from '../../../constants';
import { PaymentContext } from '../../PaymentOrchestrator/PaymentContextProvider';
import HeadingText from './HeadingText';
import SubHeading from './SubHeading';

const MOVEMENT_HEADING_OVERRIDES = {
  [`${products.identity}:${products.credit_expert}`]: { actionOverride: 'Switch to', isDeferredMovement: false },
  [`${products.credit_expert}:${products.identity}`]: { actionOverride: 'Switch to', isDeferredMovement: true },
};

const PaymentHeading = () => {
  const theme = useContext(ThemeContext);
  const {
    resolvedUpgradeOffer,
    resolvedCurrentSubscription,
    resolvedIsTrial,
    isBillingPeriodChange,
    targetBillingPeriod,
  } = useContext(PaymentContext);
  const movementHeadingOverride =
    MOVEMENT_HEADING_OVERRIDES[`${resolvedCurrentSubscription?.family}:${resolvedUpgradeOffer?.family}`];
  const isDesktop = useMediaQuery(theme.media.smallDesktopMin);
  const Heading = isDesktop ? TitleXLarge500 : TitleLarge500;

  if (isBillingPeriodChange) {
    const periodLabel = targetBillingPeriod === 'annual' ? 'annual' : 'monthly';
    return <Heading as="h1">Change to {periodLabel} billing</Heading>;
  }

  return (
    <React.Fragment>
      <Heading as="h1">
        <HeadingText
          isTrial={resolvedIsTrial}
          familyType={resolvedUpgradeOffer?.family || ''}
          actionOverride={movementHeadingOverride?.actionOverride}
          isDeferredMovement={movementHeadingOverride?.isDeferredMovement}
        />
      </Heading>
      <SubHeading isTrial={resolvedIsTrial} upgradeOffer={resolvedUpgradeOffer} />
    </React.Fragment>
  );
};

export default PaymentHeading;
